import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: '#ECECEC',
    color: '#000',
    fontWeight: 'bold'
  },
  body: {
    fontSize: 14
  }
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    // '&:nth-of-type(odd)': {
    //   backgroundColor: theme.palette.action.hover
    // }
  }
}))(TableRow);

const useStyles = makeStyles({
  table: {
    minWidth: 700
  },
  feedbackLink: {
    textDecoration: 'underline',
    cursor: 'pointer'
  }
});

const InvestorList = () => {
  const classes = useStyles();

  function createData(name, category, contact, date, reasons) {
    return { name, category, contact, date, reasons };
  }

  const rows = [
    createData(
      'PAI Partners',
      'Private Equity',
      'john@paipartners.com',
      'March 06',
      <p className={classes.feedbackLink}>see feedback</p>
    ),
    createData(
      'BlackRock',
      'Mutual Fund',
      'sandrine@blackrock.com',
      'March 05',
      <p className={classes.feedbackLink}>see feedback</p>
    ),
    createData(
      'Partech',
      'Venture Capital',
      'laurent@partechpartners.com',
      'March 03',
      <p className={classes.feedbackLink}>see feedback</p>
    ),
    createData(
      'Accel Partners',
      'Venture Capital',
      'laure@accelpartners.com',
      'Feb 28',
      <p className={classes.feedbackLink}>see feedback</p>
    )
  ];

  return (
    <TableContainer component={Paper}>
      <Table aria-label="customized table" className={classes.table}>
        <TableHead>
          <TableRow>
            <StyledTableCell>Name</StyledTableCell>
            <StyledTableCell align="left">Category</StyledTableCell>
            <StyledTableCell align="left">Contact</StyledTableCell>
            <StyledTableCell align="left">Date</StyledTableCell>
            <StyledTableCell align="left">Reasons</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <StyledTableRow key={row.name}>
              <StyledTableCell component="th" scope="row">
                {row.name}
              </StyledTableCell>
              <StyledTableCell align="left">{row.category}</StyledTableCell>
              <StyledTableCell align="left">{row.contact}</StyledTableCell>
              <StyledTableCell align="left">{row.date}</StyledTableCell>
              <StyledTableCell align="left">{row.reasons}</StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default InvestorList;
